<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">

                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2">Home</h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Home</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->

                
                <!-- Loading -->
                <div v-if="pgLoading" class="row h-100">
                    <div class="container text-center">
                        <div class="spinner-grow mt-5" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <!-- End Loading -->

            <!-- Form -->
            <form v-if="!pgLoading" @submit.prevent="editRow" enctype="multipart/form-data" class="h-100">

                <!-- Content -->
                <div class="tab-content">
                    <div class="row">      

                        <div class="col-md-12 mb-5">
                            <div class="card">
                                <div class="card-body">
                                    <div class="col-12 pt-3">

                                        <div class="form-group">
                                            <label>Image 700 * 530
                                                <button v-if="row.preview1" 
                                                    type="button" 
                                                    class="btn btn-danger btn-sm btn-pill"
                                                    style='margin-top: -10px; margin-left: 10px'
                                                    @click="row.preview1 = ''; row.image1 = ''">
                                                    Remove Image
                                                </button>
                                            </label>
                                            <p><img v-if="row.preview1" 
                                                :src="row.preview1" 
                                                style="max-width: 100%">
                                            </p>
                                            <input type="file" 
                                                class="form-control" 
                                                v-on:change="onImage1Change">
                                        </div>
                                        <div class="col-12 row" style='padding:0'>
                                            <div class="form-group col-12">
                                                <label>Title</label>
                                                
                                                <editor
                                                            id="editors0title1"
                                                            v-model="row.title1"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                            </div>
                                            
                                        </div>
                                        <div class="col-12 row" style='padding:0'>
                                            <div class="form-group col-12">
                                                <label>Button</label>
                                                <input type="text" 
                                                    v-model="row.button1" 
                                                    class="form-control">
                                            </div>
                                            <div class="form-group col-12">
                                                <label>Redirect</label>
                                                <input type="text" 
                                                    v-model="row.redirect1" 
                                                    class="form-control">
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 mt-5">
                            <div class="card">
                                <div class="card-body">
                                    <div class="col-12 pt-3">

                                        <div class="form-group">
                                            <label>Image 700 * 250
                                                <button v-if="row.preview2" 
                                                    type="button" 
                                                    class="btn btn-danger btn-sm btn-pill"
                                                    style='margin-top: -10px; margin-left: 10px'
                                                    @click="row.preview2 = ''; row.image2 = ''">
                                                    Remove Image
                                                </button>
                                            </label>
                                            <p><img v-if="row.preview2" 
                                                :src="row.preview2" 
                                                style="max-width: 100%">
                                            </p>
                                            <input type="file" 
                                                class="form-control" 
                                                v-on:change="onImage2Change">
                                        </div>
                                        <div class="col-12 row" style='padding:0'>
                                            <div class="form-group col-12">
                                                <label>Title</label>
                                                
                                                <editor
                                                            id="editors0title2"
                                                            v-model="row.title2"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                            </div>
                                           <!--  <div class="col-1">
                                                <label>Font</label>
                                                <input type="color" 
                                                    v-model="row.color2" 
                                                    style="height: 175px;width:100px">
                                            </div> -->
                                        </div>
                                        <div class="col-12 row">
                                            <div class="form-group col-12">
                                                <label>Button</label>
                                                <input type="text" v-model="row.button2" class="form-control">
                                            </div>
                                            <div class="form-group col-12">
                                                <label>Redirect</label>
                                                <input type="text" v-model="row.redirect2" class="form-control">
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 mt-5">
                            <div class="card mt-5">
                                <div class="card-body">
                                    <div class="col-12 pt-3">

                                        <div class="form-group">
                                            <label>Image 700 * 250
                                                <button v-if="row.preview3" 
                                                    type="button" 
                                                    class="btn btn-danger btn-sm btn-pill"
                                                    style='margin-top: -10px; margin-left: 10px'
                                                    @click="row.preview3 = ''; row.image3 = ''">
                                                    Remove Image
                                                </button>
                                            </label>
                                            <p><img v-if="row.preview3" 
                                                :src="row.preview3" 
                                                style="max-width: 100%">
                                            </p>
                                            <input type="file" 
                                                class="form-control" 
                                                v-on:change="onImage3Change">
                                        </div>
                                        <div class="col-12 row" style='padding:0'>
                                            <div class="form-group col-12">
                                                <label>Title</label>
                                                
                                                <editor
                                                            id="editors0title3"
                                                            v-model="row.title3"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                            </div>
                                            <!-- <div class="col-1">
                                                <label>Font</label>
                                                <input type="color" v-model="row.color3" style="height: 175px;width:100px">
                                            </div> -->
                                        </div>
                                        <div class="col-12 row">
                                            <div class="form-group col-12">
                                                <label>Button</label>
                                                <input type="text" v-model="row.button3" class="form-control">
                                            </div>
                                            <div class="form-group col-12">
                                                <label>Redirect</label>
                                                <input type="text" v-model="row.redirect3" class="form-control">
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 mt-5">
                            <div class="card mt-5">
                                <div class="card-body">
                                    <div class="col-12 pt-3">

                                        <div class="form-group">
                                            <label>Image 700 * 350
                                                <button v-if="row.preview4" 
                                                    type="button" 
                                                    class="btn btn-danger btn-sm btn-pill"
                                                    style='margin-top: -10px; margin-left: 10px'
                                                    @click="row.preview4 = ''; row.image4 = ''">
                                                    Remove Image
                                                </button>
                                            </label>
                                            <p><img v-if="row.preview4" 
                                                :src="row.preview4" 
                                                style="max-width: 100%">
                                            </p>
                                            <input type="file" 
                                                class="form-control" 
                                                v-on:change="onImage4Change">
                                        </div>
                                        <div class="col-12 row" style='padding:0'>
                                            <div class="form-group col-11">
                                                <label>Title</label>
                                                <!-- <textarea 
                                                    class="form-control" 
                                                    v-model="row.title4"
                                                    rows="3" 
                                                    style="font-size: 40px;font-weight: bold">
                                                </textarea> -->
                                                <editor
                                                            id="editors0title4"
                                                            v-model="row.title4"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                            </div>
                                            <!-- <div class="col-1">
                                                <label>Font</label>
                                                <input type="color" v-model="row.color4" style="height: 175px;width:100px">
                                            </div> -->
                                        </div>
                                        <div class="col-12 row" style='padding:0'>
                                            <div class="form-group col-12">
                                                <label>Content</label>
                                                <!-- <textarea 
                                                    rows="5"
                                                    class="form-control" 
                                                    v-model="row.desc4">
                                                </textarea> -->
                                                <editor
                                                            id="editors0desc4"
                                                            v-model="row.desc4"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                            </div>
                                            <!-- <div class="col-1">
                                                <label>Font</label>
                                                <input type="color" v-model="row.colorDesc4" style="height: 130px;width:100px">
                                            </div> -->
                                        </div>
                                        <div class="col-12 row">
                                            <div class="form-group col-12">
                                                <label>Button</label>
                                                <input type="text" v-model="row.button4" class="form-control">
                                            </div>
                                            <div class="form-group col-12">
                                                <label>Redirect</label>
                                                <input type="text" v-model="row.redirect4" class="form-control">
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 mt-5">
                            <div class="card mt-5">
                                <div class="card-body">
                                    <div class="col-12 pt-3">

                                        <div class="form-group">
                                            <label>Image 700 * 460
                                                <button v-if="row.preview5" 
                                                    type="button" 
                                                    class="btn btn-danger btn-sm btn-pill"
                                                    style='margin-top: -10px; margin-left: 10px'
                                                    @click="row.preview5 = ''; row.image5 = ''">
                                                    Remove Image
                                                </button>
                                            </label>
                                            <p><img v-if="row.preview5" 
                                                :src="row.preview5" 
                                                style="max-width: 100%">
                                            </p>
                                            <input type="file" 
                                                class="form-control" 
                                                v-on:change="onImage5Change">
                                        </div>
                                        <div class="col-12 row" style='padding:0'>
                                            <div class="form-group col-12">
                                                <label>Title</label>
                                                
                                                <editor
                                                            id="editors0title5"
                                                            v-model="row.title5"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                            </div>
                                           
                                        </div>
                                        <div class="col-12 row">
                                            <div class="form-group col-12">
                                                <label>Button</label>
                                                <input type="text" v-model="row.button5" class="form-control">
                                            </div>
                                            <div class="form-group col-12">
                                                <label>Redirect</label>
                                                <input type="text" v-model="row.redirect5" class="form-control">
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 mt-5">
                            <div class="card mt-5">
                                <div class="card-body">
                                    <div class="col-12 pt-3">

                                        <div class="form-group">
                                            <label>Image 700 * 460
                                                <button v-if="row.preview6" 
                                                    type="button" 
                                                    class="btn btn-danger btn-sm btn-pill"
                                                    style='margin-top: -10px; margin-left: 10px'
                                                    @click="row.preview6 = ''; row.image6 = ''">
                                                    Remove Image
                                                </button>
                                            </label>
                                            <p><img v-if="row.preview6" 
                                                :src="row.preview6" 
                                                style="max-width: 100%">
                                            </p>
                                            <input type="file" 
                                                class="form-control" 
                                                v-on:change="onImage6Change">
                                        </div>
                                        <div class="col-12 row" style='padding:0'>
                                            <div class="form-group col-12">
                                                <label>Title</label>
                                                
                                                <editor
                                                            id="editors0title6"
                                                            v-model="row.title6"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                            </div>
                                            
                                        </div>
                                        <div class="col-12 row" style='padding:0'>
                                            <div class="form-group col-12">
                                                <label>Content</label>

                                                <editor
                                                            id="editors0desc6"
                                                            v-model="row.desc6"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                            </div>
                                            
                                        </div>
                                        <div class="col-12 row">
                                            <div class="form-group col-12">
                                                <label>Button</label>
                                                <input type="text" v-model="row.button6" class="form-control">
                                            </div>
                                            <div class="form-group col-12">
                                                <label>Redirect</label>
                                                <input type="text" v-model="row.redirect6" class="form-control">
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="col-md-12 row mt-10">
                    <div class="form-group mr-2">
                        <button class="btn btn-primary" 
                                :disabled="btnLoading">
                            <span v-if="btnLoading">
                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                    role="status" 
                                    aria-hidden="true">
                                </span>Loading...
                            </span>
                            <span v-if="!btnLoading" class="ti-check-box"></span>
                            <span v-if="!btnLoading"> Update Home</span>
                        </button>
                    </div>

                    <div class="form-group">
                        <button type="button" 
                            class="btn btn-danger" 
                            :disabled="btnLoading" 
                            @click="cancel">
                            <span class="ti-close"></span>
                            <span> Cancel </span>
                        </button>
                    </div>
                </div>


            </form>
            <!-- End Form -->
                
            </div>
            <!-- End Content Body -->

            <Footer></Footer>
            </div>
            <!-- Content -->

        </main>
        <!-- End Main -->
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Editor from '@tinymce/tinymce-vue';
    import iziToast from 'izitoast';
    
    export default {
        name: 'Home',
        components: {
            Header,
            Navigation,
            Footer,
            Editor
        },
        data(){
            return {
                auth: { 
                    access_token: '',
                },
                row: {
                    preview1: '',
                    image1: '',
                    title1: '',
                    color1: '',
                    button1: '',
                    redirect1: '',

                    preview2: '',
                    image2: '',
                    title2: '',
                    color2: '',
                    button2: '',
                    redirect2: '',

                    preview3: '',
                    image3: '',
                    title3: '',
                    color3: '',
                    button3: '',
                    redirect3: '',

                    preview4: '',
                    image4: '',
                    title4: '',
                    color4: '',
                    desc4: '',
                    colorDesc4: '',
                    button4: '',
                    redirect4: '',

                    preview5: '',
                    image5: '',
                    title5: '',
                    color5: '',
                    button5: '',
                    redirect5: '',

                    preview6: '',
                    image6: '',
                    title6: '',
                    color6: '',
                    desc6: '',
                    colorDesc6: '',
                    button6: '',
                    redirect6: '',

                },
                editor: {
                    api_key: 'xahz1dg338xnac8il0tkxph26xcaxqaewi3bd9cw9t4e6j7b',
                    menubar: 'file edit view insert format tools table tc help',
                    plugins: [
                                'advlist autolink lists link image charmap print preview anchor',
                                'searchreplace visualblocks code fullscreen',
                                'insertdatetime media table paste code help wordcount'
                            ],
                    toolbar: 'undo redo | formatselect | bold italic backcolor | \
                              alignleft aligncenter alignright alignjustify | \
                              bullist numlist outdent indent | removeformat | help',
                },
                pgLoading: true,
                btnLoading: false,
            }
        },
        mounted() {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            this.fetchRow();
        },
        methods: {

            // fetchRow
            fetchRow() {
                this.pgLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/landingPages/1',
                    method: 'GET',
                    data: {},
                    params: {},
                }
                this.axios(options)
                    .then(res => {
                    this.pgLoading = false;

                        this.row.preview1 = res.data.row.image1;
                        this.row.image1 = res.data.row.image1;
                        this.row.title1 = res.data.row.title1;
                        this.row.color1 = res.data.row.color1;
                        this.row.button1 = res.data.row.button1;
                        this.row.redirect1 = res.data.row.redirect1;

                        this.row.preview2 = res.data.row.image2;
                        this.row.image2 = res.data.row.image2;
                        this.row.title2 = res.data.row.title2;
                        this.row.color2 = res.data.row.color2;
                        this.row.button2 = res.data.row.button2;
                        this.row.redirect2 = res.data.row.redirect2;

                        this.row.preview3 = res.data.row.image3;
                        this.row.image3 = res.data.row.image3;
                        this.row.title3 = res.data.row.title3;
                        this.row.color3 = res.data.row.color3;
                        this.row.button3 = res.data.row.button3;
                        this.row.redirect3 = res.data.row.redirect3;

                        this.row.preview4 = res.data.row.image4;
                        this.row.image4 = res.data.row.image4;
                        this.row.title4 = res.data.row.title4;
                        this.row.color4 = res.data.row.color4;
                        this.row.desc4 = res.data.row.desc4;
                        this.row.colorDesc4 = res.data.row.colorDesc4;
                        this.row.button4 = res.data.row.button4;
                        this.row.redirect4 = res.data.row.redirect4;

                        this.row.preview5 = res.data.row.image5;
                        this.row.image5 = res.data.row.image5;
                        this.row.title5 = res.data.row.title5;
                        this.row.color5 = res.data.row.color5;
                        this.row.button5 = res.data.row.button5;
                        this.row.redirect5 = res.data.row.redirect5;

                        this.row.preview6 = res.data.row.image6;
                        this.row.image6 = res.data.row.image6;
                        this.row.title6 = res.data.row.title6;
                        this.row.color6 = res.data.row.color6;
                        this.row.desc6 = res.data.row.desc6;
                        this.row.colorDesc6 = res.data.row.colorDesc6;
                        this.row.button6 = res.data.row.button6;
                        this.row.redirect6 = res.data.row.redirect6;
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // editRow
            editRow(){
                this.btnLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                const options = {
                    url: window.baseURL+'/landingPages/1',
                    method: 'PUT',
                    data: {
                        image1: this.row.image1,
                        title1: this.row.title1,
                        color1: this.row.color1,
                        button1: this.row.button1,
                        redirect1: this.row.redirect1,

                        image2: this.row.image2,
                        title2: this.row.title2,
                        color2: this.row.color2,
                        button2: this.row.button2,
                        redirect2: this.row.redirect2,

                        image3: this.row.image3,
                        title3: this.row.title3,
                        color3: this.row.color3,
                        button3: this.row.button3,
                        redirect3: this.row.redirect3,

                        image4: this.row.image4,
                        title4: this.row.title4,
                        color4: this.row.color4,
                        desc4: this.row.desc4,
                        colorDesc4: this.row.colorDesc4,
                        button4: this.row.button4,
                        redirect4: this.row.redirect4,

                        image5: this.row.image5,
                        title5: this.row.title5,
                        color5: this.row.color5,
                        button5: this.row.button5,
                        redirect5: this.row.redirect5,

                        image6: this.row.image6,
                        title6: this.row.title6,
                        color6: this.row.color6,
                        desc6: this.row.desc6,
                        colorDesc6: this.row.colorDesc6,
                        button6: this.row.button6,
                        redirect6: this.row.redirect6,
                    }
                }
                this.axios(options, config)
                    .then(() => {
                        this.btnLoading = false;
                        iziToast.success({
                            icon: 'ti-check',
                            title: 'Great job,',
                            message: 'Home Updated Successfully.',
                        });
                        //this.$router.push({ name: 'home' })
                    })
                    .catch(err => {
                        this.btnLoading = false;
                        iziToast.warning({
                            icon: 'ti-alert',
                            title: 'Wow-man,',
                            message: (err.response) ? err.response.data.message : ''+err
                        });
                    })
                    .finally(() => {})
            },

            

            // Upload Featured image
            onImage1Change(e){
                const file = e.target.files[0];
                this.row.preview1 = URL.createObjectURL(file);
                this.createBase64Image1(file);
            },
            createBase64Image1(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image1 = e.target.result;
                };
            },


            onImage2Change(e){
                const file = e.target.files[0];
                this.row.preview2 = URL.createObjectURL(file);
                this.createBase64Image2(file);
            },
            createBase64Image2(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image2 = e.target.result;
                };
            },

            onImage3Change(e){
                const file = e.target.files[0];
                this.row.preview3 = URL.createObjectURL(file);
                this.createBase64Image3(file);
            },
            createBase64Image3(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image3 = e.target.result;
                };
            },

            onImage4Change(e){
                const file = e.target.files[0];
                this.row.preview4 = URL.createObjectURL(file);
                this.createBase64Image4(file);
            },
            createBase64Image4(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image4 = e.target.result;
                };
            },

            onImage5Change(e){
                const file = e.target.files[0];
                this.row.preview5 = URL.createObjectURL(file);
                this.createBase64Image5(file);
            },
            createBase64Image5(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image5 = e.target.result;
                };
            },
            onImage6Change(e){
                const file = e.target.files[0];
                this.row.preview6 = URL.createObjectURL(file);
                this.createBase64Image6(file);
            },
            createBase64Image6(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image6 = e.target.result;
                };
            },
  


            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: 'dashboard' });
                }
            },



        },
    }
</script>
